import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'module',
    serviceName: 'graphql',
    query: gql`
      query module(
        $ids: [String]
        $type_ids: [String]
        $shop_ids: [String]
        $product_shop_ids: [String]
        $creator_ids: [String]
        $title: String
        $pages: String
        $url: String
        $start_time: String
        $end_time: String
        $has_timer: Int
        $use_for_child: Int
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        module(
          ids: $ids
          type_ids: $type_ids
          shop_ids: $shop_ids
          product_shop_ids: $product_shop_ids
          creator_ids: $creator_ids
          title: $title
          pages: $pages
          url: $url
          start_time: $start_time
          end_time: $end_time
          has_timer: $has_timer
          use_for_child: $use_for_child
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            media {
              id
              full_url
              collection_name
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteModule',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteModule($ids: [String]!) {
        deleteModule(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'module',
    serviceName: 'grapghql',
    query: gql`
      query module($ids: [String]) {
        module(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'module',
    serviceName: 'grapghql',
    query: gql`
      query module($ids: [String]) {
        module(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
